import { Layout } from '@/components/layout/Layout';
import { PageHeader } from '@/components/ui/PageHeader';
import { useBatchAccountProfile, useRefreshBatchAccountProfile } from '@/api/hooks/useBatchAccountProfile';
import { EmailSection } from './profile/EmailSection';
import { PasswordSection } from './profile/PasswordSection';
import { PasskeysSection } from './profile/PasskeysSection';
import { DeleteAccountSection } from './profile/DeleteAccountSection';
import { usePageTitle } from '@/hooks/usePageTitle';

export function ProfilePage() {
    usePageTitle('Account');

    const { data, isLoading, error } = useBatchAccountProfile();
    const refreshData = useRefreshBatchAccountProfile();

    return (
        <Layout>
            <div className="max-w-3xl">
                <div className="space-y-2">
                    <PageHeader title="Account" />
                    <p className="text-gray-600 dark:text-gray-400">
                        Manage your email, password, and sign-in methods.
                    </p>
                </div>

                <div className="mt-8 space-y-6">
                    <EmailSection
                        profile={data?.profile ?? null}
                        isLoading={isLoading}
                        error={error}
                        onRefresh={refreshData}
                    />
                    <PasswordSection />
                    <PasskeysSection
                        passkeys={data?.passkeys?.passkeys ?? null}
                        isLoading={isLoading}
                        error={error}
                        onRefresh={refreshData}
                    />
                    <DeleteAccountSection />
                </div>
            </div>
        </Layout>
    );
}
